import action from './action'

export default {
    getColors() {
        return action.request('get_welcom_colors')
    }
}
